export const useStateIsAuthenticated = () => useState<boolean>("isAuthenticated", () => false);

export enum LoginStatus {
    None = "none",
    Pending = "pending",
    Error = "error",
    Success = "success",
    Complete = "complete",
}

export const useStateLoginStatus = () => useState<LoginStatus>("loginStatus", () => LoginStatus.None);

export const useStateUserInfo = () =>
    useState<UserInfo>("userInfo", () => ({
        IsCookieConsentNeeded: false,
        AcceptsAnalyticsCookies: false,
        AcceptsTargetingCookies: false,
        Roles: [],
    }));

export const useStateLocationInfo = () =>
    useState<LocationInfo>("locationInfo", () => ({
        CountryCode: "US",
        CurrencyCode: "USD",
        RegionId: 1,
        HomeRegionId: 1,
    }));

export const useStateRegionInfo = () => useState<RegionInfo[]>("regionInfo", () => []);

export const useStateCurrencyInfo = () => useState<CurrencyInfo[]>("currencyInfo", () => []);

export const useStateFeatureFlags = () => useState<FeatureFlags>("featureFlags", () => EMPTY_FEATURE_FLAGS);

export const useStateSearchText = () => useState<string>("searchText", () => "");

export const useStateSearchFilters = () =>
    useState<SearchFilters>("searchFilters", () => ({ inStock: false, manufacturerIds: [], distributorIds: [] }));

export const useStateIsBot = () => useState<boolean>("isBot", () => false);

export const useStateHasSpecialPricing = () => useState<boolean>("hasSpecialPricing", () => false);
